<template>
<div class="contents_855">
  <header-bar active="wash-history"></header-bar>

  <h1 class="title2">{{ $t('usageHistory') }}</h1>

  <div class="contents_box">
    <table class="mp_tb wash_history">
      <tbody>
        <tr>
          <td bgcolor="#e5f5fa"><p>{{ $t('washRequest.plan') }}</p></td>
          <td bgcolor="#e5f5fa"><p>{{ $t('washRequest.pickupDeliveryTime') }}</p></td>
        </tr>
        <tr v-for="wreq in histories">
          <th>
            <p>
            <span class="wreq_mst_name p1">{{wreq.mst_name_p1}}</span>
            <span class="wreq_mst_name sl">/</span>
            <br class="wreq_mst_name br">
            <span class="wreq_mst_name p2">{{wreq.mst_name_p2}}</span>
            </p>
          </th>
          <td>
            <p v-if="wreq.sched_pickup_dt_from" class="mp_tb_con">
              {{ $t('washRequest.pickup') }}：{{wreq.sched_pickup_dt_from | dtFormat($t('dateTimeFormat.shortDateWithWeekday'))}}
              <br>
              {{wreq.sched_pickup_dt_from | dtFormat($t('dateTimeFormat.time'))}}
              〜
              {{wreq.sched_pickup_dt | dtFormat($t('dateTimeFormat.time'))}}
            </p>
            <p v-else class="mp_tb_con">
              {{ $t('washRequest.pickup') }}：{{wreq.sched_pickup_dt | dtFormat($t('dateTimeFormat.shortDateTimeWithWeekday'))}}
            </p>
            <p class="mp_tb_con">
              <span v-if="wreq.pdSameTime">
                {{ $t('washRequest.delivery') }}：<span class="font_orange">{{ $t('washRequest.deliverOnNextPickup') }}</span>
              </span>
              <span v-else>
                <p v-if="wreq.sched_delivery_dt_from">
                  {{ $t('washRequest.delivery') }}：{{wreq.sched_delivery_dt_from | dtFormat($t('dateTimeFormat.shortDateWithWeekday'))}}
                  <br>
                  {{wreq.sched_delivery_dt_from | dtFormat($t('dateTimeFormat.time'))}}
                  〜
                  {{wreq.sched_delivery_dt | dtFormat($t('dateTimeFormat.time'))}}
                </p>
                <p v-else>
                  {{ $t('washRequest.delivery') }}：{{wreq.sched_delivery_dt | dtFormat($t('dateTimeFormat.shortDateTimeWithWeekday'))}}
                </p>
              </span>
            </p>
            <p class="mp_tb_con">
              {{ $t('washRequest.details') }}：{{wreq.mst_size}}／{{wreq.count}}{{ $t('washRequest.unit') }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import userApi from '@/api/user'
import { isOnetimeTypeAlphaAvailable } from '@/utils/areaInfoUtil'
import { isOnetimePlan, isPickupDeliverySameTime } from '@/utils/planUtils'
import { setScheduleFromDatetime } from '@/utils/washRequestUtils'

export default {
  name: 'wash-history',
  data() {
    return {
      histories: []
    }
  },
  async mounted() {
    const token = this.$store.getters['localStorage/serverToken']
    if (!token) {
      this.$router.push({name: 'login'})
    }
    const onetimeTypeAlphaAvailable = await isOnetimeTypeAlphaAvailable(this.$store)
    window.master.$promise.then(mst => {
      // Business Rule No.28 履歴は最大6か月前まで確認できる
      const oldestDt = new Date(new Date().valueOf() - 86400*180*1000)
      const dateStrToDate = Vue.filter('dateStrToDate')
      // Business Rule No.29 履歴は1ページに10件まで表示⇛60件に変更
      const maxHistoryCount = 60

      userApi.getMyWashRequests().then(({ data }) => {
        this.histories = data.filter(e => {
          if (isPickupDeliverySameTime(e.plan_id)) {
            e.pdSameTime = true
            // 既に集荷が終わってるやつ
            return !!e.result_pickup_dt
          } else {
            e.pdSameTime = false
            // 既に配達が終わってるやつ
            return !!e.result_delivery_dt
          }
        }).filter(e => {
          if (e.pdSameTime) {
            return dateStrToDate(e.result_pickup_dt) > oldestDt
          } else {
            return dateStrToDate(e.result_delivery_dt) > oldestDt
          }
        }).map(e => {
          e.mst_name = mst.planMap[e.plan_id].name
          if (isOnetimePlan(e.plan_id)) {
            e.mst_size = this.$t('master.planPart.tx') + '（45L）'
            if (onetimeTypeAlphaAvailable) {
              setScheduleFromDatetime(e)
            }
          } else {
            e.mst_size = mst.lovsMap['size'][mst.planMap[e.plan_id].size].val + this.$t('size')
          }
          const arr = e.mst_name.split('/')
          e.mst_name_p1 = arr[0]
          e.mst_name_p2 = arr[1]
          return e
        }).slice(0, maxHistoryCount)
      })
    })
  },
}
</script>

<style lang="scss" scoped>
</style>
